import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { collections as collectionsApi } from '../api';
import './Browse.css';

const Browse = () => {
  const { user } = useAuth();
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    collectionsApi.getAll().then(data => setCollections(data.collections));
  }, []);

  return (
    <div className="browse-page">
      <nav className="nav">
        <div className="nav-content">
          <Link to="/" className="logo">C3</Link>
          <div className="nav-links">
            {user ? (
              <Link to="/dashboard" className="btn-secondary">Dashboard</Link>
            ) : (
              <Link to="/login" className="btn-secondary">Login</Link>
            )}
          </div>
        </div>
      </nav>

      <div className="browse-content">
        <h1>All Collections</h1>
        <div className="collections-grid">
          {collections.map(coll => (
            <div key={coll.collectionId} className="collection-card">
              <h3>{coll.title}</h3>
              <p>{coll.description}</p>
              <div className="collection-meta">
                <span>{coll.totalCards} cards</span>
                <span>{coll.domains.length} domains</span>
                <span className="price">${(coll.price / 100).toFixed(2)}</span>
              </div>
              <Link to={`/collection/${coll.collectionId}`} className="btn-primary">Learn More</Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Browse;
